module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "mb-4 text-center"
  }, [_c('span', {
    staticClass: "number-words"
  }, [_vm._v(_vm._s(_vm.totalWords) + " Words")])]), _vm._v(" "), _c('div', {
    staticClass: "w-full relative h-10 bg-gray-200 dark:bg-gray-700"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "h-10 flex dark:bg-gray-300",
    style: (_vm.progessBarStyle)
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line",
    staticStyle: {
      "left": "25%"
    }
  }, [_c('div', {
    staticClass: "number"
  }, [_vm._v("10")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line",
    staticStyle: {
      "right": "25%"
    }
  }, [_c('div', {
    staticClass: "number"
  }, [_vm._v("30")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-02fbdfc9!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/onlineRoundtables/components/summaryComponents/AverageComment.vue
// module id = 1129
// module chunks = 61